import { ContactaProps } from './Contacta.types';
// @ts-ignore
import Text from 'components/corporatiu/Text';
// @ts-ignore
import Titol from 'components/corporatiu/Titol/Titol';
// @ts-ignore
import Tabs from 'components/corporatiu/Tabs';

const Contacta = (props: Readonly<ContactaProps>) => {
    const { items, tabs } = props;
    const title = items?.titol;
    const description = items?.descripcio;
    const resolvedTabs = tabs || items?.tabs;

    return (
        <>
            <Titol titol={title} tipus='menu' tag='h1' estil='titolPagina' />
            <Text text={description} className='gapAfterRow' />
            <Tabs tabs={resolvedTabs} id='contacta-tabs' estil='faqs' />
        </>
    );
};

export default Contacta;
